"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE = exports.Status = exports.DivulgationType = void 0;

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const TYPE = {
  // ===== Valores adicioniais =====
  ADDITION: 1,
  // ===== Forma de cobrança =====
  PRICE: 2,
  PERCENT: 4,
  // ===== Cobrar com base em =====
  CART: 8,
  DELIVERY: 16,
  // ===== Tipo de uso do cupom =====
  FIRST_PURCHASE_EVER: 32,
  N_USE: 64,
  FREE_TO_USE: 128,
  NEXT_PURCHARSE: 256
};
exports.TYPE = TYPE;
const Status = {
  PAUSED: 'PAUSED',
  ACTIVE: 'ACTIVE'
};
exports.Status = Status;
const DivulgationType = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};
exports.DivulgationType = DivulgationType;

class Gift extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "id", null);

    _defineProperty(this, "code", null);

    _defineProperty(this, "type", null);

    _defineProperty(this, "value", null);

    _defineProperty(this, "divulgation", null);

    _defineProperty(this, "status", null);

    _defineProperty(this, "expiration", null);

    _defineProperty(this, "min_order", null);

    _defineProperty(this, "users", []);

    _defineProperty(this, "times", 1);

    _defineProperty(this, "description", null);

    _defineProperty(this, "availability", null);

    _defineProperty(this, "show", null);

    _defineProperty(this, "created_at", null);
  }

  getValue(cartValue, deliveryValue = 0) {
    let baseValue = this.typeIs(TYPE.DELIVERY) ? deliveryValue : this.typeIs(TYPE.CART) ? cartValue : 0;
    let v = this.value || 0;
    let finalGiftValue = 0;

    if (this.typeIs(TYPE.PERCENT)) {
      finalGiftValue = baseValue * Math.min(v, 100) / 100;
    } else if (this.typeIs(TYPE.PRICE)) {
      finalGiftValue = !this.typeIs(TYPE.ADDITION) ? Math.min(baseValue, v) : v;
    }

    return +(Math.abs(finalGiftValue) * (this.typeIs(TYPE.ADDITION) ? 1 : -1)).toFixed(2);
  }

  static fromObject(obj) {
    let gift = new Gift();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'id':
        case 'code':
        case 'type':
        case 'value':
        case 'divulgation':
        case 'min_order':
        case 'users':
        case 'description':
        case 'expiration':
        case 'availability':
        case 'show':
        case 'created_at':
          gift[key] = value;
          break;

        case 'times':
          gift[key] = value || 1;
          break;

        case 'status':
          gift[key] = value || Status.ACTIVE;
          break;
      }
    });
    return gift;
  }

  isExpired(expiration) {
    return expiration !== null && expiration < new Date().getTime() / 1000;
  }

  validate() {
    let me = this;

    if (this.trigger('gift/isOnlineOrigin')) {
      if ([this.type, this.code, this.value].indexOf(null) > -1) {
        throw new Error('Cupom inválido!');
      }

      let gift = this.trigger('gift/checkGift');
      let props = ['code', 'type', 'value', 'times'];
      props.forEach(prop => {
        if (me[prop] != gift[prop]) throw new Error('Cupom inválido!');
      });

      if (this.isExpired(this.expiration)) {
        throw new Error('Cupom expirado!');
      }

      if (this.status === Status.PAUSED) {
        throw new Error('Cupom pausado!');
      }
    }

    let cartTotal = this.trigger('gift/getCartTotal');

    if (this.min_order > cartTotal) {
      throw new Error('Valor minimo não alcançado!');
    }

    if (this.users && this.users.length > 0) {
      let userId = this.trigger('gift/getUserId');
      let user = this.users.filter(u => u.user_id == userId);

      if (user.length == 0) {
        throw new Error('Cupom inválido!');
      }

      if (this.typeIs(TYPE.NEXT_PURCHARSE)) {
        user = users[0];
        let lastOrder = this.trigger('gift/getLastOrder');

        if (new Date(lastOrder.created_at) > new Date(user.startedBy)) {
          throw new Error('Esse cupom não é mais válido!');
        }
      }
    }

    if (this.typeIs(TYPE.FIRST_PURCHASE_EVER) || this.typeIs(TYPE.N_USE)) {
      let orderCount = this.trigger('gift/countOrders');

      if (orderCount == 0 ? true : orderCount <= (this.times || 1)) {
        return true;
      }
    } else if (this.typeIs(TYPE.FREE_TO_USE) || this.typeIs(TYPE.NEXT_PURCHARSE)) {
      return true;
    }

    throw new Error('Cupom inválido!');
  }

  typeIs(type) {
    return (this.type & type) == type;
  }

}

exports.default = Gift;